var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.schedule)?_c('div',{staticClass:"animated"},[_c('b-progress',{attrs:{"max":_vm.max,"height":"1rem"}},[_c('b-progress-bar',{attrs:{"value":_vm.value,"variant":_vm.variant}},[_c('strong',[_vm._v(_vm._s(_vm.value)+" / "+_vm._s(_vm.max))])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }